export default "__VITE_ASSET__hbysWhzc__"